import React from 'react';
import {Button, FormControl, FormGroup, Glyphicon, HelpBlock, Modal, Table} from 'react-bootstrap';
import PropTypes from 'prop-types';
import EditableAction from './EditableAction';
import validator from 'validator';
import moment from 'moment';
import './NotesModal.css';


class NotesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewNote: false,
      newNote: '',
      validation: '',
    };
  }

  toggleShowNewNote = () => {
    this.setState(prevState => ({
    showNewNote: !prevState.showNewNote
    }));
  }

  handleChange = (event) => {
    const target = event.target;
    this.setState({newNote: target.value});
  }

  onNoteSubmit = () => {
    if(!validator.isEmpty(this.state.newNote)) {
      this.props.onCreateNote({note: this.state.newNote});
      this.setState({showNewNote: false, newNote: '', validation: ''});
    } else {
      this.setState({validation: 'Required field'});
    }
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Notes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table data-cy="notes-table">
            <thead>
              <tr>
                <th>Date</th>
                <th/>
                <th/>
              </tr>
            </thead>
            <tbody>
              { this.props.notes &&
                this.props.notes.map((n, i) => {
                  return (
                    <tr key={i}>
                      <td>{moment(new Date(n.date_added)).format('MM/DD/YYYY')}</td>
                      <td><EditableAction value={n.note} onSubmit={(note) => this.props.onEditNote({...n, note})}/></td>
                      <td><Button data-cy="delete-note-button" className='pull-right' onClick={() => this.props.onDeleteNote(n)}><Glyphicon glyph='trash'/></Button></td>
                    </tr>
                  );
                })
              }
              <tr>
                <td/>
                <td>
                  {
                    this.state.showNewNote &&
                    <div className='flex-row'>
                      <FormGroup validationState={this.state.validation ? 'error' : null}>
                        <FormControl componentClass={'textarea'} value={this.state.newNote} onChange={this.handleChange}/>
                        {this.state.validation &&
                        <HelpBlock>{this.state.validation}</HelpBlock>
                        }
                      </FormGroup>
                      <a data-cy='submit-note-button' onClick={this.onNoteSubmit}><Glyphicon style={{ fontSize: '15px', marginLeft: '10px' }} glyph='ok'/></a>
                    </div>
                  }
                </td>
                <td>
                  {
                    !this.state.showNewNote &&
                    <Button className='pull-right' data-cy="add-note-button" onClick={() => this.setState({showNewNote: true})}><Glyphicon glyph={'plus-sign'}/></Button>
                  }
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    );
  }
}

NotesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onEditNote: PropTypes.func.isRequired,
  onCreateNote: PropTypes.func.isRequired,
  onDeleteNote: PropTypes.func.isRequired,
  notes: PropTypes.array,
};

export default NotesModal;


// WEBPACK FOOTER //
// ./src/components/engagement/NotesModal.js